<template>
  <v-app>

    <router-view/>



    <sg-root-modal />
    <sg-root-snackbar />



  </v-app>
</template>

<script>
import SgRootModal from './SgRootModal'
import SgRootSnackbar from './SgRootSnackbar'
/* import SgRootLoader from './SgRootLoader' */

export default {
      components: {
      SgRootModal,
      SgRootSnackbar,
  /*     SgRootLoader */
    },
}
</script>

<style>
</style>
